<div mat-dialog-title>
  <h1>Connect to TypeDB</h1>
  <tp-modal-close-button />
</div>
<div class="tp-modal-content">
  <tp-scroll-container class="tp-modal-body" mat-dialog-content>
    @if (ready$ | async) {
      <h2>Get an API Token</h2>
      <p>Use the following HTTP request to get an API token for your database</p>
      @if (httpAPICommand$ | async; as command) {
        <div class="tp-code">
          <tp-code-snippet [snippet]="{ language: 'shell', code: command.replaceAll(' --', ' \\\n  --') }"/>
          <button
            class="btn-copy" aria-label="copy" matTooltip="Copy to clipboard"
            (click)="copy(command, snackbar); $event.stopPropagation();"
          >
            <i class="fa-light fa-copy"></i>
          </button>
        </div>
      }
      @if (data.cluster$ | async; as cluster) {
        <p>
          Your database password can be found in your downloaded credentials file if you have one
          (by default: <strong>{{ clusterCredentialFilename(cluster) }}</strong>).
        </p>
      }
      <hr/>
      <h2>Connect to TypeDB</h2>
      <p>View the <a class="tp-external-link" [href]="httpAPIDocsLink$ | async" target="_blank">HTTP API documentation<i class="fa-light fa-arrow-up-right"></i></a> for instructions on how to use your token to query your database through the API</p>
    } @else if (loading$ | async) {
      @if (parsedVersion$ | async; as version) {
        <tp-cluster-loading-tips [clusterVersion]="version"/>
      }
    }
  </tp-scroll-container>
</div>
